import type {
	IssueTypeEdgesWithoutFieldConfig,
	IssueTypeToFieldsConfiguration,
} from '../controllers/use-ai-create-project-context/types';

/**
 * Builds a mapping of isqsue type IDs to their corresponding field configuration GraphQL nodes for a given project.
 * Iterates over the project's issue types and constructs an object where each key is an issue type ID,
 * and each value is the result of transforming the issue type node using `toIssueType`.
 *
 * @param project - The project GraphQL node containing issue types, or `null`/`undefined`.
 * @returns An object mapping issue type IDs to their field configurations.
 */
export function buildIssueTypeToFieldsConfiguration(
	issueTypeEdges?: IssueTypeEdgesWithoutFieldConfig,
): IssueTypeToFieldsConfiguration {
	const issueTypeToFieldsConfiguration: IssueTypeToFieldsConfiguration = {};

	issueTypeEdges?.forEach((issueTypeEdge) => {
		const issueTypeNode = issueTypeEdge?.node;
		const issueTypeId = issueTypeNode?.issueTypeId;
		if (!issueTypeId) {
			return;
		}

		issueTypeToFieldsConfiguration[issueTypeId] = {
			issueTypeId: String(issueTypeNode.issueTypeId),
			name: issueTypeNode.name,
			hierarchyLevel: issueTypeNode.hierarchy?.level ?? 0,
			avatarUrl: issueTypeNode.avatar?.small ?? undefined,
			fieldsConfigurationNode: Object.fromEntries(
				(issueTypeNode.fieldsConfiguration?.edges ?? [])
					.map((edge) => (edge?.node ? [edge.node?.fieldId, edge.node] : []))
					.filter((entry) => entry.length > 0),
			),
		};
	});

	return issueTypeToFieldsConfiguration;
}
